/*
 * Copyright (c) 2026 Paxia AI Pty Ltd. All rights reserved.
 * This software is proprietary and confidential.
 * No part of this codebase may be copied, modified, published, distributed, sublicensed, or used without prior written permission from Paxia AI Pty Ltd.
 */

import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';

/**
 * Main layout for AI platform pages.
 * Navigation is handled by the global Sidebar (frontend/src/components/Sidebar.jsx).
 * This layout provides consistent content padding for all AI pages.
 * Individual pages should NOT add their own root-level padding.
 */
export const MainLayout: React.FC = () => {
  return (
    <Box
      component="main"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        minHeight: 0,
        width: '100%',
        p: { xs: 1, sm: 1.5, md: 2 },
        overflowX: 'clip',
      }}
    >
      <Outlet />
    </Box>
  );
};

export default MainLayout;
